<template>
  <MainContainer />
</template>

<script>
import MainContainer from "./containers/MainContainer.vue";
export default {
  name: "reset-password",
  components: {
    MainContainer,
  },
};
</script>
